import { FormatGeschaeftsnummerPipe } from './format-geschaeftsnummer.pipe';
import { Pipe, PipeTransform } from '@angular/core';
import { DatumPipe } from '../simple/datum.pipe';
import { BelegEntry } from '../../../core/gb-api';
import { KompaktAmtnummerPipe } from '../../kompaktdarstellung/amt/kompakt-amtnummer-pipe';

@Pipe({
  name: 'formatBeleg'
})
export class FormatBelegPipe implements PipeTransform {
  constructor(
    private datum: DatumPipe,
    private geschaeftsnummer: FormatGeschaeftsnummerPipe,
    private kompaktamt: KompaktAmtnummerPipe
  ) {}

  transform(beleg: BelegEntry, mitDatum: boolean = true): string {
    if (!beleg || !beleg.geschaeftsnummer) {
      return;
    }
    let datum = '';
    if (beleg.datum && mitDatum) {
      datum = this.datum.transform(beleg.datum) + ' ';
    }

    const geschaeftsnummer = beleg.geschaeftsnummer;
    if (geschaeftsnummer.amtNummer && geschaeftsnummer.jahr) {
      return datum + this.geschaeftsnummer.transform(beleg.geschaeftsnummer);
    } else if (beleg.hasOwnProperty('alt')) {
      return datum + this.kompaktamt.transform(geschaeftsnummer.amtNummer) + beleg.alt;
    }
  }
}
